"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveNavItem = exports.isActiveNavFlyout = void 0;

var _getGlobalFromWindow = _interopRequireDefault(require("../../shared/helpers/getGlobalFromWindow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isActiveNavItem = function isActiveNavItem(url) {
  return window.location.href.match(url);
};

exports.isActiveNavItem = isActiveNavItem;

var isActiveNavFlyout = function isActiveNavFlyout(category) {
  var homeURL = "".concat((0, _getGlobalFromWindow["default"])('homeURL'), "/");
  var windowLocation = (window.location.origin + window.location.pathname).toString().toLowerCase();
  var activeSubgroups;
  var isHomePage = windowLocation === homeURL.toLowerCase();

  if (isHomePage) {
    return false;
  }

  if (category.subGroups && category.subGroups.length > 0) {
    activeSubgroups = filterNavSubgroups(category.subGroups, windowLocation);
  }

  return !!(activeSubgroups && activeSubgroups.length > 0);
};

exports.isActiveNavFlyout = isActiveNavFlyout;

var filterNavSubgroups = function filterNavSubgroups(subGroups, windowLocation) {
  var activeItems = subGroups.filter(function (subGroup) {
    var items = subGroup.items;
    return items.find(function (item) {
      var linkStart = item.indexOf('(') + 1;
      var linkEnd = Math.max(item.lastIndexOf('{'), 0) || item.length - 1;
      var link = item.substring(linkStart, linkEnd).toLowerCase();
      var linkLength = link.length;
      return linkLength >= windowLocation.length && windowLocation.substring(0, linkLength) === link;
    });
  });
  return activeItems;
};